<template>
  <div
    v-if="formSpec"
    class="checkin-container"
    v-loading.fullscreen.lock="display.isLoading"
  >
    <h3 class="centre">{{ formSpec.name }}</h3>
    <p class="centre">{{ formSpec.description }}</p>
    <el-form
      class="checkin-form"
      ref="formResult"
      :model="formResult"
      :rules="formRules"
    >
      <div v-for="field in formSpec.fields" :key="field.name">
        <el-form-item :prop="field.name">
          <el-input
            v-model="formResult[field.name]"
            :placeholder="
              `${field.name} ${field.isMandatory ? ' (Required)' : ''}`
            "
          ></el-input>
        </el-form-item>
      </div>
      <div class="centre">
        <el-button class="bg-gold black" @click="onClickCheckIn"
          >Check In</el-button
        >
      </div>
    </el-form>

    <el-dialog
      :fullscreen="true"
      :visible.sync="display.dialogs.checkInSuccess.isVisible"
      :show-close="false"
    >
      <div class="centre" v-if="checkInResult">
        <h3>You have been successfully checked in</h3>
        <div>
          <i class="el-icon-success checkin-success"></i>
        </div>
        <h2>{{ checkInResult.createdTimeDisplay }}</h2>
        <h3><strong>Please show this page to our staff</strong></h3>
        <el-button class="bg-gold black" @click="onClickGoHome"
          >Check Our Menu Now</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import { getCheckInForm, submitCheckInForm } from "@/api/form";
import { getMe } from "@/api/customer";
import logger from "@/utils/logger";

const name = "Order";
const log = logger(name);

export default {
  data() {
    return {
      display: {
        isLoading: true,
        dialogs: {
          checkInSuccess: { isVisible: false }
        }
      },
      formSpec: null,
      formResult: {},
      checkInResult: null
    };
  },
  computed: {
    formRules() {
      if (this.formSpec) {
        return this.formSpec.fields.reduce(
          (cur, inc) =>
            Object.assign(cur, {
              [inc.name]: [
                {
                  required: inc.isMandatory,
                  message: `${inc.name} is required`,
                  trigger: "blur"
                }
              ]
            }),
          {}
        );
      }
      return null;
    },
    ...mapGetters(["token"])
  },
  async created() {
    await this.fetchForm();
    if (this.token) {
      log.info("User signed in, prefilling");
      await this._prefill();
    }
  },
  methods: {
    async fetchForm() {
      this.display.isLoading = true;
      const formSpec = await getCheckInForm();
      this.formSpec = formSpec;
      this.formResult = this.formSpec.fields.reduce(
        (cur, inc) => Object.assign(cur, { [inc.name]: "" }),
        {}
      );
      this.display.isLoading = false;
    },

    onClickCheckIn() {
      this.display.isLoading = true;
      this.$refs["formResult"].validate(async valid => {
        if (!valid) {
          log.warn("Checkin form invalid");
          this.display.isLoading = false;
          return false;
        }
        try {
          const result = await submitCheckInForm(this.formResult);
          this.display.dialogs.checkInSuccess.isVisible = true;
          result.createdTimeDisplay = moment(result.createdTime).format(
            "ddd h:mma, D MMM YYYY"
          );
          this.checkInResult = result;
        } catch (err) {
          log.error("Error when submitting check in form", err);
        } finally {
          this.display.isLoading = false;
        }
      });
    },

    onClickGoHome() {
      this.$router.replace(
        `/?selectedCategoryId=${process.env.VUE_APP_FROM_CHECKIN_SELECTED_CATEGORY_ID ||
          "5e755a4c2bf500001899c10c"}`
      );
    },

    async _prefill() {
      this.display.isLoading = true;
      const me = await getMe();
      this.formResult = {
        "First Name": me.firstName,
        "Last Name": me.surname,
        Mobile: me.phone,
        "Email Address": me.email,
        Postcode: (me.streetAddress && me.streetAddress.zipCode) || ""
      };
      this.display.isLoading = false;
    }
  }
};
</script>

<style scoped>
.checkin-container {
  padding: 1rem;
}

.checkin-form >>> input {
  border-radius: 0 !important;
  border: 1px solid #c5b899;
}

.checkin-success {
  font-size: 8rem;
  color: #67c23a;
}
</style>